import { render, staticRenderFns } from "./payOrder.vue?vue&type=template&id=85da149e&scoped=true"
import script from "./payOrder.vue?vue&type=script&lang=js"
export * from "./payOrder.vue?vue&type=script&lang=js"
import style0 from "./payOrder.vue?vue&type=style&index=0&id=85da149e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85da149e",
  null
  
)

export default component.exports